import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const departments = (state = initialState.departments, action) => {
  switch (action.type) {
    case types.LOAD_DEPARTMENT_SUCCESS:
      return action.departments;

    default:
      return state;
  }
};

export const department = (state = initialState.department, action) => {
  switch (action.type) {
    case types.GET_DEPARTMENT_SUCCESS:
      return action.department;

    default:
      return state;
  }
};
